import type React from "react";

export const JuiceIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  const { width = 50, height = 50, color = "#6a33ff", ...restProps } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={width}
      height={height}
      x="0"
      y="0"
      viewBox="0 0 64 64"
      xmlSpace="preserve"
      {...restProps}
    >
      <title>Juice icon</title>
      <g>
        <path
          d="m48.264 11.068.979-3.915A2.838 2.838 0 0 1 52 5.001h5V3h-5a4.835 4.835 0 0 0-4.698 3.668l-1.091 4.362c-4.931.305-9.308 3.442-11.205 7.97h23.993a12.914 12.914 0 0 0-10.736-7.932zM31 40c.379 0 .725.214.895.553l.629 1.258 2.377-.68L34.684 37h-1.683c-.155 0-.309-.036-.447-.105l-4.553-2.276v2.259l.781 3.123h2.219zM9.515 36.857l-3.438 2.062 4.04 2.021 3.641-.91a1.002 1.002 0 0 1 .843.17l2.795 2.096.635-2.538c.056-.224.187-.42.37-.558l2.261-1.695-6.877-1.528a1.001 1.001 0 0 1-.783-.977v-3.132l-1.445.964a1.003 1.003 0 0 1-.555.168H8.62l1.276 2.553a1.001 1.001 0 0 1-.38 1.305zM33 21v2h28v-2zM37.788 57.947A3.221 3.221 0 0 0 41.005 61h11.989a3.221 3.221 0 0 0 3.217-3.053L57.945 25H36.053l1.734 32.947z"
          fill={color}
          opacity="1"
          data-original="#000000"
        ></path>
        <path
          d="m19.852 40.714-.882 3.528a1.002 1.002 0 0 1-1.57.558l-3.619-2.714-3.538.884a1.009 1.009 0 0 1-.69-.075L6.94 41.589C4.437 43.685 3 46.71 3 50.001c0 6.065 4.935 11 11 11s11-4.935 11-11c0-3.794-1.965-7.277-5.148-9.286z"
          fill={color}
          opacity="1"
          data-original="#000000"
        ></path>
        <path
          d="M32.275 43.962a1 1 0 0 1-1.17-.515L30.381 42h-2.382a.999.999 0 0 1-.97-.758l-.394-1.575a8.926 8.926 0 0 0-2.817 1.821A12.987 12.987 0 0 1 26.999 50c0 2.097-.511 4.073-1.396 5.828A8.937 8.937 0 0 0 29.999 57a8.976 8.976 0 0 0 5.631-1.99l-.623-11.829-2.733.781z"
          fill={color}
          opacity="1"
          data-original="#000000"
        ></path>
      </g>
    </svg>
  );
};
